/** Marker separating the bold portion of a heading from the regular-weight portion. */
export const SPLIT_MARK = '§';

/** Remove the split marker — for plain-text contexts (document title, alt text). */
export function stripSplit(text: string): string {
  return text.split(SPLIT_MARK).join('');
}
